<template>
  <div class="resource-themes-page" v-if="doc">
    <ResourceThemesList
      v-for="(slice, index) in doc.data.body"
      :key="index"
      :doc="slice.primary.tile_carousel_embed_link"
    ></ResourceThemesList>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  CmsDocument,
  CmsResourceTheme,
  CmsResourceThemesPage,
} from "../../services/cms/cms-type-definitions";
import ResourceThemesList from "../../components/cms/resource-themes-list.vue";

const props = defineProps<{ doc: CmsDocument | null }>();

const doc = computed(() => props.doc as CmsResourceThemesPage);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
